import React from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";

const Faq=()=>{

return (<>
    <div className="home">
                <div id="page" className="hfeed page-wrapper">
                    
<Header/>
<div id="site-main" className="site-main">
  <div id="main-content" className="main-content">
    <div id="primary" className="content-area">
      {/* <div id="title" className="page-title">
        <div className="section-container">
          <div className="content-title-heading">
            <h1 className="text-title-heading">Refunds &amp; Returns</h1>
          </div>
          <div className="breadcrumbs">
            <a href="index.html">Home</a>
            <span className="delimiter" />
            Returns Policy
          </div>
        </div>
      </div> */}
      <br></br>
      <div id="content" className="site-content" role="main">
        <div className="page-contact">
          <section className="section section-padding">
            <div className="faq-section">
              <h2 className="faq-title">Frequently Asked Questions</h2>
              <div className="faq-container">
                <div className="faq-item">
                  <button className="faq-question">
                    Is it safe ordering online?
                  </button>
                  <div className="faq-answer">
                    <p>
                      We are 100% committed to providing a safe ecommerce
                      shopping experience. To date we have satisfied over
                      50,000+ happy customers and our aim is always to deliver
                      first-class customer care.
                    </p>
                    <h2>State-of-the-art ecommerce security</h2>
                    <p>
                      Our website is protected with the latest security
                      certificates (SSL certificates). These certificates use
                      state-of-the-art encryption technologies so that you can
                      have complete peace of mind when shopping online with us.
                    </p>
                    <h2>PCI Compliant</h2>
                    <p>
                      Our systems are compliant with the PCI Security Standards
                      Council, which was founded by Visa, MasterCard, American
                      Express and JCB International. You can find out more about
                      the PCI Security Standards Council at
                      www.pcisecuritystandards.org.
                    </p>
                    <h2>Verified by Visa and MasterCard</h2>
                    <p>
                      We also use Visa and MasterCard Secure Code technology for
                      processing all orders.
                    </p>
                    <h2>Get In Touch</h2>
                    <p>
                      If you would like to talk to a member of our Customer Care
                      Team about ordering by telephone, please get in touch on
                      020 7138 3672 or enter into a live chat .
                    </p>
                  </div>
                </div>
                <div className="faq-item">
                  <button className="faq-question">
                    What payment methods are accepted??
                  </button>
                  <div className="faq-answer">
                    <p>
                      We are happy for you to make payment by any of the
                      following methods:
                    </p>
                    <h4>Credit or debit card</h4>
                    <p>We accept all major credit and debit cards.</p>
                    <h4>V12</h4>
                    <p>
                      V12 provides a range of finance options with varying loan
                      terms, from 6 months IFC at 0% APR to 12 months IFC at 0%
                      APR, as well as 12 months classic credit at 9.9% APR up to
                      48 months classic credit at 9.9% APR. Once you've added
                      items to your bag, head to checkout and select the payment
                      plan that works best for you. After paying a deposit for
                      your item, the remaining amount can be paid off in
                      instalments over time.
                    </p>
                    <h4>Klarna</h4>
                    <p>
                      Klarna offers you the flexibility to choose how you'd like
                      to pay for your purchase. You can either opt to Pay in 3
                      instalments or Pay in 30 days. For both options, your
                      total order value must be between £100 and £499. Simply
                      add your items to the cart, proceed to checkout, and
                      select Klarna as your payment method to complete the
                      purchase. Credit approval is subject to eligibility.
                    </p>
                    <p>
                      Klarna's Pay in 3 / Pay in 30 days are unregulated credit
                      agreements. Borrowing more than you can afford or paying
                      late may negatively impact your financial status and
                      ability to obtain credit. 18+, UK residents only. Subject
                      to status. Ts&amp;Cs and late fees apply.
                    </p>
                    <h4>PayPal</h4>
                    <p>
                      We are pleased to accept payments via PayPal, simply
                      select this payment option during the checkout process. If
                      you wish to pay via this method over the phone, simply
                      contact our customer care team and we will send you a
                      PayPal request. Upon receipt of the request, simply make
                      the payment and email us with the payment details. You
                      shall then receive the order confirmation against your
                      order.
                    </p>
                    <h4>Bank Transfer</h4>
                    <p>
                      We can also accept payments via bank transfer, simply call
                      or email the customer care team if you wish to pay by this
                      method.
                    </p>
                    <h4>Cheque</h4>
                    <p>
                      We are also happy to receive payment via cheque. Contact a
                      member of our customer care team if you require further
                      information on this payment method.
                    </p>
                    <h4>Telephone</h4>
                    <p>
                      We can accept payment over the phone. Simply contact our
                      customer care team where they will ask for your card and
                      order details to take the payment.
                    </p>
                    <h4>Get in touch</h4>
                    <p>
                      If you would like to talk to a member of our customer care
                      team about payment options, please get in touch on 020
                      7138 3672 or enter into a live chat .
                    </p>
                  </div>
                </div>
                <div className="faq-item">
                  <button className="faq-question">
                    My card details have been rejected?
                  </button>
                  <div className="faq-answer">
                    <p>
                      If your card details have been rejected there are a number
                      of possible reasons as to why this may be. Please check
                      the below reasons, alternatively simply get in touch with
                      our customer care team where they will be happy to take
                      the payment from over the phone.
                    </p>
                    <h4>Reasons for a card payment rejection</h4>
                    <p>
                      The vast majority of reasons why a card is rejected are
                      because of the protection policies of the bank. You may
                      have to phone your bank to tell them that you wish to
                      purchase a high-value item.
                    </p>
                    <h4>
                      Alternatively, you may have incorrectly input any of the
                      below information:
                    </h4>
                    <li>Card Holder Name</li>
                    <li>Credit Card Number</li>
                    <li>
                      Card security code (3-4 security code on the back of your
                      card)
                    </li>
                    <li>Postcode</li>
                    <h4>Get in touch</h4>
                    <p>
                      If you would like to talk to a member of our Customer Care
                      Team about making payment over the telephone, please get
                      in touch on 020 7138 3672 .
                    </p>
                  </div>
                </div>
                <div className="faq-item">
                  <button className="faq-question">
                    How long does it take to receive a refund?
                  </button>
                  <div className="faq-answer">
                    <p>
                      Depending upon the payment method used it can take between
                      8-10 working days for a refund to be processed. Our
                      excellent customer service team will be happy to notify
                      you of estimated refund times at the point when a refund
                      is agreed.
                    </p>
                    <h4>Get in touch</h4>
                    <p>
                      If you would like to talk to a member of our Customer Care
                      Team about making payment over the telephone, please get
                      in touch on 020 7138 3672 .
                    </p>
                  </div>
                </div>
                <div className="faq-item">
                  <button className="faq-question">
                    Will I get a VAT refund form?
                  </button>
                  <div className="faq-answer">
                    <p>
                      VAT (value added tax) is applicable for all orders placed
                      on this website. All the products displayed online are
                      inclusive of VAT. The VAT Retail Export Scheme allows the
                      VAT amount to be reimbursed to customers when they
                      purchase goods in the EU and then export them outside the
                      EU. However, orders from West End are ineligible for the
                      VAT Retail Export Scheme because we are an internet-based
                      mail-order company and therefore not eligible to
                      participate.
                    </p>
                    <h4>Get in touch</h4>
                    <p>
                      If you would like to talk to a member of our Customer Care
                      Team about making payment over the telephone, please get
                      in touch on 020 7138 3672 .
                    </p>
                  </div>
                </div>
                <div className="faq-item">
                  <button className="faq-question">
                    Am I eligible for VAT-free purchases?
                  </button>
                  <div className="faq-answer">
                    <p>
                      VAT (Value Added Tax) is collected for all the shipments
                      within the European Union. If you are located outside of
                      the EU territory or countries which are exempt of VAT,
                      simply get in touch with our customer care team on 020
                      7138 3672 and they will help you make your purchase over
                      the telephone.
                    </p>
                    <h4>Get in touch</h4>
                    <p>
                      If you would like to talk to a member of our Customer Care
                      Team about making payment over the telephone, please get
                      in touch on 020 7138 3672 .
                    </p>
                  </div>
                </div>
                <div className="faq-item">
                  <button className="faq-question">
                    Do you offer discount codes?
                  </button>
                  <div className="faq-answer">
                    <p>
                      Yes, we are pleased to be able to offer discount codes
                      wherever possible and do so throughout the year.
                    </p>
                    <h4>Get in touch</h4>
                    <p>
                      If you would like to talk to a member of our Customer Care
                      Team about making payment over the telephone, please get
                      in touch on 020 7138 3672 .
                    </p>
                  </div>
                </div>
                <div className="faq-item">
                  <button className="faq-question">
                    Can I pay with two credit cards?
                  </button>
                  <div className="faq-answer">
                    <p>
                      If you wish to use two cards for one transaction this is
                      definitely possible. You just need to make sure that both
                      cards belong to the same owner and are registered at the
                      same billing address. Simply call our customer care team
                      so they can take your payments over the phone.
                    </p>
                    <h4>Get in touch</h4>
                    <p>
                      If you would like to talk to a member of our Customer Care
                      Team about making payment over the telephone, please get
                      in touch on 020 7138 3672 .
                    </p>
                  </div>
                </div>
                <div className="faq-item">
                  <button className="faq-question">Do you price match?</button>
                  <div className="faq-answer">
                    <p>
                      Yes, we are proud to offer a price guarantee that means we
                      aim to match like-for-like prices. If you wish to take
                      advantage of this service please get in touch with our
                      customer care team and provide details of the price and
                      product that you would like us to match.
                    </p>
                    <h4>Get in touch</h4>
                    <p>
                      If you would like to talk to a member of our Customer Care
                      Team about making payment over the telephone, please get
                      in touch on 020 7138 3672 .
                    </p>
                  </div>
                </div>
                <div className="faq-item">
                  <button className="faq-question">
                    When do you take payment from my card?
                  </button>
                  <div className="faq-answer">
                    <p>
                      Once you make a payment your bank will authorise the
                      amount for the transaction that you have made. The actual
                      settlement for the amount between your account and our
                      account is usually completed in around 2-3 days. The payee
                      will be itemised as Neve Jewels Ltd, which owns the West
                      End brand.
                    </p>
                    <h4>Get in touch</h4>
                    <p>
                      If you would like to talk to a member of our Customer Care
                      Team about making payment over the telephone, please get
                      in touch on 020 7138 3672 .
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>
      </div>
      {/* #content */}
    </div>
    {/* #primary */}
  </div>
  {/* #main-content */}
</div>

<Footer/>
</div>

</div>

</>)




}

export default Faq;